import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title> MSIM Consulting || {this.props.pageTitle} </title>
                    <meta name="description" content="MSIM Consulting." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
